import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

export const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="home" className="relative pt-36 pb-32 overflow-hidden bg-slate-950" data-testid="hero">
      {/* Corporate buildings background with motion */}
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://customer-assets-jai6qajn.emergentagent.net/job_credit-connect-26/artifacts/w2kgexvu_web2.jpg"
          alt="Corporate buildings - LOANYARD CAPITAL"
          className="absolute inset-0 w-full h-full object-cover hero-slow-zoom opacity-40"
          loading="eager"
          fetchPriority="high"
          decoding="async"
          data-testid="hero-image"
        />
        {/* Premium left-to-right daylight sweep */}
        <div className="hero-light-sweep" aria-hidden="true"></div>
        {/* Dark institutional gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-slate-950/90 via-slate-950/60 to-slate-950/20"></div>
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(16,185,129,0.12),transparent_65%)]"></div>
      </div>

      <div className="container mx-auto px-4 relative">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="inline-block">
              <span className="bg-white/10 backdrop-blur-sm border border-emerald-400/30 text-emerald-300 px-5 py-2 rounded-full text-sm font-medium tracking-wide">
                Corporate Finance &amp; Capital Advisory
              </span>
            </div>
            
            <h1 className="heading-hero text-white leading-tight">
              Capital Structured Around 
              <span className="text-emerald-400"> Your Ambitions</span>
            </h1>
            
            <p className="body-large text-slate-200 leading-relaxed mt-6">
              LOANYARD CAPITAL is a corporate finance firm delivering debt, equity, capital syndication, structured finance and M&amp;A solutions for HNIs, promoters, family businesses and corporates.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                onClick={() => scrollToSection('contact')}
                size="lg"
                className="bg-emerald-600 hover:bg-emerald-500 text-white text-lg px-8 py-6 h-auto shadow-lg shadow-emerald-900/40"
              >
                Discuss Your Requirement
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
              <Button 
                onClick={() => scrollToSection('capital-solutions')}
                size="lg"
                variant="outline"
                className="border border-white/40 bg-transparent text-white hover:bg-white/10 hover:text-white text-lg px-8 py-6 h-auto backdrop-blur-sm"
              >
                Explore Capital Solutions
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
